import WMSCapabilities from 'ol/format/WMSCapabilities';
export const getWMSCapabilities = async (urlStr) => {
    const url = new URL(urlStr, window.location.href);
    url.searchParams.set('request', 'GetCapabilities');
    url.searchParams.set('service', 'WMS');
    const parser = new WMSCapabilities();
    try {
        const response = await fetch(url.href);
        const text = await response.text();
        const capabilities = parser.read(text);
        return capabilities;
    }
    catch (err) {
        console.error('Error during service getWMSCapabilities: ', url.href);
    }
    return null;
};
//# sourceMappingURL=getWMSCapabilities.js.map